import { ENUM__error_type } from '@shared/asserts/ENUM__error_type';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ERROR_GRAPH__base } from './ERROR_GRAPH__base';

export class ERROR_GRAPH__node extends ERROR_GRAPH__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.ERROR_GRAPH_NODE;

  /*
   * STATIC METHODS
   */

  static create(type: ENUM__error_type, node_id: string = ENUM__string_id_empty.UUID) {
    let out = new ERROR_GRAPH__node();

    out.type = type;
    out.node_id = node_id;

    return out;
  }

  node_id!: string;

  /*
   * METHODS
   */

  override is_equals(other: ERROR_GRAPH__base): boolean {
    if (!super.is_equals(other)) return false;
    if (!(other instanceof ERROR_GRAPH__node)) return false;

    return other.node_id == this.node_id;
  }
}
